import { ArrowRight, CheckCircle, Lightning } from "@phosphor-icons/react";

const DOT = {
  block: "bg-red-400",
  warn: "bg-amber-400",
  info: "bg-zinc-500",
};

export const ProjectNextSteps = ({ steps = [], nextStage, onGo }) => {
  if (steps.length === 0)
    return (
      <div
        data-testid="project-next-steps"
        className="flex items-center gap-2.5 rounded-lg border border-emerald-500/30 bg-emerald-500/[0.06] px-4 py-3 text-sm text-emerald-200"
      >
        <CheckCircle size={18} weight="fill" className="shrink-0 text-emerald-400" />
        <span data-testid="next-steps-clear">
          All clear — nothing is blocking this project
          {nextStage ? `. Ready to advance to ${nextStage}.` : "."}
        </span>
      </div>
    );
  const blocking = steps.filter((s) => s.level === "block").length;
  const watch = steps.length - blocking;
  return (
    <section
      data-testid="project-next-steps"
      className="rounded-lg border border-zinc-800 bg-zinc-900 p-4"
    >
      <div className="flex flex-wrap items-center gap-2">
        <Lightning size={16} weight="fill" className="text-amber-300" />
        <h2 className="text-xs font-bold uppercase tracking-widest text-zinc-300">
          Next steps
        </h2>
        <span
          data-testid="next-steps-summary"
          className="ml-auto text-[10px] font-bold uppercase tracking-widest text-zinc-500"
        >
          {blocking > 0 && (
            <span className="text-red-300">{blocking} blocking</span>
          )}
          {blocking > 0 && watch > 0 && " · "}
          {watch > 0 && <span>{watch} to watch</span>}
        </span>
      </div>
      <ul className="mt-2 divide-y divide-zinc-800/70">
        {steps.map((s) => (
          <li
            key={s.key}
            data-testid={`next-step-${s.key}`}
            data-level={s.level}
            className="flex items-center gap-3 py-2.5"
          >
            <span className={`h-2 w-2 shrink-0 rounded-full ${DOT[s.level]}`} />
            <span
              className={`min-w-0 flex-1 text-sm ${
                s.level === "info" ? "text-zinc-400" : "text-zinc-100"
              }`}
            >
              {s.text}
            </span>
            <button
              type="button"
              data-testid={`next-step-go-${s.key}`}
              onClick={() => onGo(s)}
              className="inline-flex h-8 shrink-0 items-center gap-1 rounded-full border border-zinc-700 px-3 text-[10px] font-bold uppercase tracking-widest text-zinc-300 transition-colors duration-150 hover:border-indigo-500 hover:text-indigo-200"
            >
              {s.cta} <ArrowRight size={11} weight="bold" />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
